<template>
<div>
	<ul class="list-group mt-2 mb-2">
		<li v-for="(component,index) in reportedComponentWork" class="list-group-item d-flex justify-content-between align-items-center">
			<strong>
				<span v-if="component.item_number">{{ component.item_number }}</span>
				<template v-if="'name' in component">: {{ component.name }}</template>
			</strong>

			<div class="d-flex align-items-center">
				<form-group label="Hours Worked"
					col-class="col-auto"
					style="margin-bottom: 0;">

					<div class="d-flex">
						<field
							:params="{
								type: 'number',
								min:0,max:24,step:0.25,placeholder:'0.00'
							}"
							v-model="component.regular_hours"
							style="width: 70px">
							Reg Hrs
						</field>

						<field v-if="$store.timeLogSettings.uses_overtime_15x == 1"
							:params="{
								type: 'number',
								min:0,max:24,step:0.25,placeholder:'0.00'
							}"
							v-model="component.overtime_hours_15x"
							style="width: 70px">
							OT 1.5x
						</field>

						<field v-if="$store.timeLogSettings.uses_overtime_2x == 1"
							:params="{
								type: 'number',
								min:0,max:24,step:0.25,placeholder:'0.00'
							}"
							v-model="component.overtime_hours_2x"
							style="width: 70px">
							OT 2x
						</field>

						<field v-if="$store.timeLogSettings.uses_overtime_25x == 1"
							:params="{
								type: 'number',
								min:0,max:24,step:0.25,placeholder:'0.00'
							}"
							v-model="component.overtime_hours_25x"
							style="width: 70px">
							OT 2.5x
						</field>
					</div>
				</form-group>

				<i class="fa fa-trash text-danger icon-button ml-4" v-on:click="removeReportedComponentWork(index)"></i>
			</div>
		</li>
	</ul>

	<button v-if="!showComponentPicker" class="btn btn-primary mb-2" type="button" v-on:click="chooseAreasOfWork">
		Choose Areas of Work...
	</button>

	<div v-else class="mb-2">
		<p>Select from the list of options:</p>

		<h5>Project Components</h5>
		<bid-component-picker
			:project-id="project.id"
			:depth="project.detailed_timelogs_depth"
			v-on:bidSet="setBid"
			v-on:componentSelected="componentSelected">		
		</bid-component-picker>

		<div v-if="changeOrders.length > 0">
			<h5>Change Orders</h5>
			<ul class="list-group mb-2">
				<li v-for="co in changeOrders" class="list-group-item-action list-group-item" v-on:click="changeOrderSelected(co)">
					CO{{ project.job_num }}-{{ co.quote_num }}<span v-if="co.request_num" class="text-muted"> - {{ co.request_num }}</span>
				</li>
			</ul>
		</div>

		<button v-on:click="showComponentPicker = false" class="btn btn-light" type="button">
			Done
		</button>
	</div>

	<div v-if="reportedComponentWork.length > 0" class="alert text-dark" :class="{'alert-light' : !detailedHoursMatchClaim, 'alert-success' : detailedHoursMatchClaim}">
		<div  class="text-right d-flex mt-2 mb-2 align-items-center justify-content-between">
			<div class="d-flex align-items-center">
				<i class="fa fa-2x mr-2"
					:class="{
						'text-success fa-check-circle' : detailedHoursMatchClaim,
						'text-danger fa-times-circle' : !detailedHoursMatchClaim
					}">		
				</i>

				<div v-if="!detailedHoursMatchClaim" class="text-muted">Your detailed reporting claim does not match your total hours claim</div>
			</div>

			<div class="d-flex justify-content-end">
				<div v-if="totalDetailedHours.regular_hours > 0" class="ml-2">
					Regular Hrs: <strong>{{ totalDetailedHours.regular_hours.toFixed(2) }}</strong>
				</div>
				<div v-if="totalDetailedHours.overtime_hours_15x > 0" class="ml-2">
					OT 1.5x Hrs: <strong>{{ totalDetailedHours.overtime_hours_15x.toFixed(2) }}</strong>
				</div>
				<div v-if="totalDetailedHours.overtime_hours_2x > 0" class="ml-2">
					OT 2x Hrs: <strong>{{ totalDetailedHours.overtime_hours_2x.toFixed(2) }}</strong>
				</div>
				<div v-if="totalDetailedHours.overtime_hours_25x > 0" class="ml-2">
					OT 2.5x Hrs: <strong>{{ totalDetailedHours.overtime_hours_25x.toFixed(2) }}</strong>
				</div>

				<div>Total: <strong>{{ totalDetailedHours.total.toFixed(2) }}</strong></div>
			</div>
		</div>
	</div>
</div>
</div>
</template>
<script type="text/javascript">
import BidComponentPicker from "@/components/super_components/BidComponentPicker"
import FormGroup from "@/components/FormGroup"
import Field from "@/components/Field"

export default {
	name: "DetailedTimeAllocator",
	components: {
		FormGroup,
		Field,
		BidComponentPicker,
	},
	props: ["value","project","log"],
	data() {
		return {
			reportedComponentWork: [],
			showComponentPicker: false,
			projectBid: null,
			changeOrders: []
		}
	},
	watch: {
		value() {
			this.reportedComponentWork = this.value
		}
	},
	computed: {
		totalDetailedHours() {
			let hrTypes = ["regular_hours","overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"]

			let totals = {
				total: 0
			}

			hrTypes.forEach(type => {
				let total = this.reportedComponentWork.reduce((acc, item) => type in item && item[type] ? acc + +item[type] : acc,0)

				if (isNaN(total))
					total = 0

				totals[type] = total
				totals.total += total
			})

			return totals
		},
		detailedHoursMatchClaim() {
			let vm = this
			let hrTypes = ["regular_hours","overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"]
			let totalClaim = 0

			let allMatch = true
			hrTypes.forEach(type => {
				totalClaim += +vm.log[type]

				if (type in vm.log && vm.totalDetailedHours[type] != vm.log[type]) 
					allMatch = false
			})

			if (totalClaim == 0)
				return false

			return allMatch
		}
	},
	methods: {
		setBid(bid) {
			this.projectBid = bid
		},
		chooseAreasOfWork() {
			this.showComponentPicker = true

			if (this.changeOrders.length == 0) {
				this.fetchChangeOrders(this.project.id)
			}
		},
		componentSelected(component) {
			this.reportedComponentWork.push({
				component_id: component.id,
				item_number: component.item_number,
				name: component.name,
				regular_hours: 0
			})

			this.$emit("input",this.reportedComponentWork)
		},
		changeOrderSelected(co) {
			this.reportedComponentWork.push({
				change_quote_id: co.id,
				item_number: "CO" + this.project.job_num + "-" + co.quote_num,
				regular_hours: 0
			})

			this.$emit("input",this.reportedComponentWork)
		},
		removeReportedComponentWork(index) {
			this.reportedComponentWork.splice(index,1)

			this.$emit("input",this.reportedComponentWork)
		},
		fetchChangeOrders(jobId) {
			let vm = this

			let params = {
				filters: [
					["job_id",jobId],
					["hide_from_detailed_reporting",0]
				]
			}

			this.getJSON("JobChangeOrder/get",params).then(response => {
				if (response.success)
					vm.changeOrders = response.data
			})
		},
		fetchTimeLogSettings() {
			let vm = this

			this.getJSON("TimeLogSetting/get").then(response => {
				if (response.success)
					vm.$store.timeLogSettings = response.data[0]
			})
		}
	},
	created() {
		if (!this.$store.timeLogSettings || Object.keys(this.$store.timeLogSettings).length == 0)
			this.fetchTimeLogSettings()
	}
}
</script>